export default __webpack_public_path__ + "static/media/eye-doctor-optometrist-and-ophthalmologist.6cf32a9e.jpg";